import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './UsersList.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";
import { Col, Container, Form, Row } from "react-bootstrap";
import useAuth from "../../hooks/useAuth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef } from "react";
import { faCheck, faTimes, faInfoCircle, faBlackboard, } from "@fortawesome/free-solid-svg-icons";
import { debounce } from "lodash";


const ListSthanUsersInArthikSakha = () => {

  const searchByName = async (searchTerm) => {
    try {
      const response = await axiosPrivate.get(`/list-sthan-users-in-arthik-sakha?arthik_sakha_id=${arthikSakhaId}&name=${searchTerm}&mobile=`);

      setSthanUsersInArthikSakhas(response.data);
    } catch (err) {
      console.error("Search error", err);
      setError("Search failed. Please try again.");
    }
  };

  const searchByMobile = async (searchTerm) => {
    try {
      const response = await axiosPrivate.get(`/list-sthan-users-in-arthik-sakha?arthik_sakha_id=${arthikSakhaId}&name=&mobile=${searchTerm}`);

      setSthanUsersInArthikSakhas(response.data);
    } catch (err) {
      console.error("Search error", err);
      setError("Search failed. Please try again.");
    }
  };


  const [nameSearchTimeout, setNameSearchTimeout] = useState(null);
  const [mobileSearchTimeout, setMobileSearchTimeout] = useState(null);

  const handleAddSthan = (personId, name, mobile) => {
    const encodedName = encodeURIComponent(name);
    const encodedMobile = encodeURIComponent(mobile);

    navigate(`/arthiksakha/add/SthanToUser?person_id=${personId}&name=${encodedName}&mobile=${encodedMobile}`);
  };

  const handleNameChange = (e) => {
    const value = e.target.value.replace(/[^a-zA-Z\s]/g, '');
    setName(value);

    // Clear previous timeout
    if (nameSearchTimeout) {
      clearTimeout(nameSearchTimeout);
    }

    // Set new timeout for debounce
    const timeout = setTimeout(() => {
      if (value.length > 1) {
        searchByName(value);
      } else {
        fetchSthanUsersInArthikSakha(); // Load full list again
      }
    }, 500);

    setNameSearchTimeout(timeout);
  };

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    setMobile(value); // use appropriate state

    // Clear previous timeout
    if (mobileSearchTimeout) {
      clearTimeout(mobileSearchTimeout);
    }

    // Set new timeout for debounce
    const timeout = setTimeout(() => {
      if (value.length > 1) {
        searchByMobile(value);
      } else {
        fetchSthanUsersInArthikSakha(); // Load full list again
      }
    }, 500);

    setMobileSearchTimeout(timeout);
  };

  const nameRef = useRef();
  const mobRef = useRef();
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");

  const [SthanUsersInArthikSakhas, setSthanUsersInArthikSakhas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const SthanUsersInArthikSakhasPerPage = 15;
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const { auth } = useAuth();
  // const [selectedArthikSakhaId, setSelectedArthikSakhaId] = useState();
  const [arthikSakhaId, setArthikSakhaId] = useState(auth?.level_id); // default value


  const fetchSthanUsersInArthikSakha = useCallback(async () => {
    setError(null); // clear previous error
    try {
      const response = await axiosPrivate.get(`list-sthan-users-in-arthik-sakha?arthik_sakha_id=${arthikSakhaId}`, {

        withCredentials: true,
      });
      const SthanUsersInArthikSakhaList = response.data;
      setSthanUsersInArthikSakhas(SthanUsersInArthikSakhaList);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Vibhags:", error);
      setError(error?.response?.data?.message?.toString() || error?.message || "No Vibhags available.");
      setLoading(false);
    }
  }, [axiosPrivate, arthikSakhaId]); // 👈 dependency added



  const handleChangePswdClick = (Id, Name) => {
    navigate(`/change/SthanUserPswd/${Id}/${Name}`);
  };

  const handleEditClick = (personId, Name, Mobile, Responsibility) => {
    const responsibilityValue = Responsibility || 'Nill'; // fallback to empty string if undefined or null
    navigate(`/update/sthanUser/${personId}/${Name}/${Mobile}/${responsibilityValue}`);
  };



  useEffect(() => {
    fetchSthanUsersInArthikSakha();
  }, [arthikSakhaId]);






  const indexOfLastSthanUsersInArthikSakha = currentPage * SthanUsersInArthikSakhasPerPage;
  const indexOfFirstSthanUsersInArthikSakha = indexOfLastSthanUsersInArthikSakha - SthanUsersInArthikSakhasPerPage;
  const currentSthanUsersInArthikSakha = SthanUsersInArthikSakhas.slice(indexOfFirstSthanUsersInArthikSakha, indexOfLastSthanUsersInArthikSakha);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(SthanUsersInArthikSakhas.length / SthanUsersInArthikSakhasPerPage);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  // if (error) {
  //   return <div className="error">{error}</div>;
  // }

  return (
    <>
      {/* <Container> */}
      <section className="empbody">
        <div className="wrapperemp2">

          <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
          {/* <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create Vibhag</button> */}
          <h3>Active sthan users in <span className="colorChange">{auth?.level_name}</span>  arthiksakha </h3>

          <Row className="mb-3">
            <Col md={1}></Col>
            <Col md={5}>
              <div className="input-box arthik_input-box">
                <input
                  className="newinputstyles"
                  type="text"
                  id="name"
                  placeholder="Search by name"
                  autoComplete="off"
                  ref={nameRef}
                  onChange={handleNameChange}
                  value={name}
                />
              </div>
            </Col>

            <Col md={5}>

              <div className="input-box arthik_input-box">
                <input
                  className="newinputstyles"
                  type="text"
                  id="name"
                  placeholder="Search by mobile number"
                  autoComplete="off"
                  ref={mobRef}
                  onChange={handleMobileChange}
                  value={mobile}
                />
              </div>


            </Col>
            <Col md={1}></Col>
          </Row>
          <div className="table-container">
            <table id="customers">
              <thead>
                <tr>
                  <th>Name of user</th>
                  <th>Mobile</th>
                  <th>OTP</th>
                  <th>Expiry</th>
                  <th>No of sthans</th>
                  <th>Options</th>
                </tr>
              </thead>

              <tbody>
                {error ? (
                  <tr>
                    <td colSpan="6" className="text-danger text-center">
                      {error}
                    </td>
                  </tr>
                ) : SthanUsersInArthikSakhas.length === 0 ? (
                  <tr>
                    <td colSpan="6">No Data available.</td>
                  </tr>
                ) : (
                  currentSthanUsersInArthikSakha.map(SthanUsersInArthikSakha => (
                    <tr key={SthanUsersInArthikSakha.user_id}>
                      <td>{SthanUsersInArthikSakha.nameofuser}</td>
                      <td>{SthanUsersInArthikSakha.mobile}</td>
                      <td>{SthanUsersInArthikSakha.otp}</td>
                      <td>{SthanUsersInArthikSakha.expiry}</td>
                      <td>{SthanUsersInArthikSakha.sthans}</td>

                      <td>
                        <div className="d-flex justify-content-center">
                          <button type="button" className="tableButton btn btn-info newicobtn newviewbtn" onClick={() => handleChangePswdClick(SthanUsersInArthikSakha.user_id, SthanUsersInArthikSakha.nameofuser)}>
                            Change Password
                          </button>


                          <button type="button" className="tableButton btn btn-info newicobtn newviewbtn" onClick={() =>
                            handleAddSthan(
                              SthanUsersInArthikSakha.person_id,
                              SthanUsersInArthikSakha.nameofuser,
                              SthanUsersInArthikSakha.mobile
                            )
                          }
                          >
                            Add sthan
                          </button>

                          <button type="button" className="btn btn-warning btn-ico newicobtn" onClick={() => handleEditClick(SthanUsersInArthikSakha.person_id, SthanUsersInArthikSakha.nameofuser, SthanUsersInArthikSakha.mobile, SthanUsersInArthikSakha.responsibility)}>
                            <i className="bx bxs-edit icon"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>


            </table>
          </div>

          {totalPages > 1 && (
            <div className="pagination">
              <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  onClick={() => handlePageChange(index + 1)}
                  disabled={currentPage === index + 1}
                >
                  {index + 1}
                </button>
              ))}
              <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
            </div>
          )}
        </div>
      </section>
      <TopBar />
      {/* </Container> */}
    </>
  );
};

export default ListSthanUsersInArthikSakha;